<template>
  <two-sides-modal
    v-model="showModal"
    title="Productos en liquidación"
    subtitle="Instrucciones"
    caption="Seleccione el producto que desee para enviarlo a su carrito de compras."
    icon="mdi-file-document-alert-outline"
  >
    <v-alert v-if="loadingError" dense outlined type="error" class="my-4">
      {{ loadingError }}
    </v-alert>

    <div v-if="loadingMaterials" class="text-center my-4">
      <v-progress-linear indeterminate color="black" class="mb-2" />
      Cargando productos...
    </div>

    <clearance-list-toolbar
      v-if="!loadingMaterials && !loadingError"
      :customer="customer"
      :center="center"
      @onSearch="(e) => (search = e)"
    />

    <v-radio-group
      v-if="!loadingMaterials && !loadingError"
      v-model="sortOption"
      class="pt-0 pb-2"
      row
      hide-details
      dense
    >
      <v-radio
        v-for="option in sortOptions"
        :key="option.value"
        :label="option.label"
        :value="option.value"
        color="black"
      />
    </v-radio-group>

    <v-virtual-scroll
      :items="filteredMaterials"
      :height="isMobileOrTablet ? '175' : '213'"
      :item-height="isMobileOrTablet ? '127' : '125'"
      :bench="4"
    >
      <template #default="{ item }">
        <clearance-list-item
          :material="item"
          :on-add-material-to-cart="onAddMaterialToCart"
          class="mr-2"
        />
      </template>
    </v-virtual-scroll>
    <template slot="actions">
      <v-scroll-y-transition>
        <div v-if="search">{{ filteredMaterials.length }} Resultados</div>
      </v-scroll-y-transition>
    </template>
  </two-sides-modal>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import ClearanceListItem from './ClearanceListItem.vue';
  import TwoSidesModal from '@/components/modals/TwoSidesModal.vue';
  import ClearanceListToolbar from './ClearanceListToolbar.vue';

  import { mapActions, mapGetters } from 'vuex';
  export default {
    name: 'ClearanceMaterialsModal',

    components: { TwoSidesModal, ClearanceListItem, ClearanceListToolbar },
    props: {
      value: Boolean,

      onAddMaterialToCart: {
        type: Function,
        requred: true,
      },
      customer: {
        type: Number,
        require: true,
      },
      center: {
        type: String,
      },
    },
    data() {
      return {
        search: null,

        sortOption: 'lowestPrice',
        sortOptions: [
          { value: 'lowestPrice', label: 'Precio ↓' },
          { value: 'highestDiscount', label: 'Descuento ↑' },
        ],
      };
    },
    computed: {
      ...mapGetters('clearanceMaterials', [
        'clearanceMaterials',
        'loadingMaterials',
        'loadingError',
      ]),

      sortedMaterials() {
        if (this.sortOption === 'highestDiscount') {
          return [...this.clearanceMaterials].sort(
            (a, b) => b.discount - a.discount
          );
        }

        // They are ordered by price from backend
        return this.clearanceMaterials;
      },

      filteredMaterials() {
        if (this.search) {
          return this.sortedMaterials.filter((m) => {
            const name = m.name || '';
            return (
              name.toLowerCase().includes(this.search.toLowerCase()) ||
              m.code.includes(this.search)
            );
          });
        }

        return this.sortedMaterials;
      },

      showModal: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },
    },
    async mounted() {
      await this.loadClearanceMaterials({
        customer: this.customer,
        center: this.center,
      });
    },
    methods: {
      ...mapActions('clearanceMaterials', ['loadClearanceMaterials']),
    },
  };
</script>
